import { render, staticRenderFns } from "./BankEditor.vue?vue&type=template&id=f5cb1ae8&scoped=true"
import script from "./BankEditor.vue?vue&type=script&lang=js"
export * from "./BankEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5cb1ae8",
  null
  
)

export default component.exports